<template>
  <header class="header">
    <div class="wrapper">
      <div class="flex">
        <div class="flex-left">
          <router-link to="/" class="logo">
            <img src="./../assets/logo.svg" class="img"/>
          </router-link>
        </div>
        <div class="flex-right">
          <ul class="nav">
            <template v-for="item in typeOptions">
              <li class="nav__item" :key="item.id">
                <div :class="['desc', {'active' : $parent.appActiveType ==  item.title}]" @click="$emit('chooseType', item)">
                  {{$t(item.title)}}
                </div>
              </li>
              <li v-if="item.title === 'Images'" class="nav__item"  :key="item.id">
                <router-link  to="/bundle-list/images" class="desc">
                 IMAGE BUNDLES
                </router-link>
              </li>
            </template>
            <!-- <li class="nav__item">
              <router-link to="/escrow" class="desc">
                {{$t('Escrow service')}}
              </router-link>
            </li> -->
          </ul>
          <div class="header-profile" v-if="$parent.isAuth">
            <div class="select-container cart" v-if="curr && ($parent.currencyOptions.length > 1)">
              <select class="select currency-select" v-model="curr"
                      @change="selectCurr()"
              >
                <option :value="item" v-for="item in currOptions" :key="item">{{$t(item)}}</option>
              </select>
            </div>
            <router-link to="/cart" class="profile-desc cart-button" v-if="$parent.cartContents">
              <div :class="['icon button' , {'blue': !$parent.cartContents.length}, {'not-blue': $parent.cartContents.length}]">
                <img class="img" src="./../assets/cart.svg"/>
              </div>
              <div class="indicator desc small" v-if="$parent.cartContents.length">
                <b>{{ $parent.cartContents.length }}</b>
              </div>
            </router-link>
            <router-link class="profile-desc" to="/profile/order-history">
              <div class="icon button blue">
                <img class="img" src="./../assets/user.svg"/>
              </div>
            </router-link>
          </div>
          <div v-else class="buttons">
            <div class="select-container cart" v-if="curr && ($parent.currencyOptions.length > 1)">
              <select class="select currency-select" v-model="curr"
                      @change="selectCurr()"
              >
                <option :value="item" v-for="item in currOptions" :key="item">{{$t(item)}}</option>
              </select>
            </div>
            <div class="button" @click="$emit('openSignInModal')">
              {{$t('Login')}}
            </div>
            <div class="button blue" @click="$emit('openSignUpModal')">
              {{$t('Sign Up')}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { RouterLink } from 'vue-router';


export default {
    name: 'Header',
    props: ['currencyCode', 'currencyValue'],
    data: function () {
        return {
            curr: '',
            typeOptions: []
        };
    },
    computed: {
        currOptions() {
            return this.$parent.currencyOptions.map(({ code }) => code);
        }
    },
    watch: {
        currencyCode: function (newValue) {
            this.curr = newValue;
        }
    },
    mounted() {
        this.curr = this.currencyCode;
        this.$http.get(process.env.VUE_APP_API + 'categories')
            .then((res) => {
            this.typeOptions = res.data.payload.filter(item => item.parent_id === null);
        })
            .catch(() => {
        });
    },
    methods: {
        openSignInModal() {
            this.$emit('openSignInModal');
        },
        openSignUpModal() {
            this.$emit('openSignUpModal');
        },
        scrollToSection(section) {
            this.$emit('scrollToSection', section);
        },
        selectCurr() {
            this.changeCurrency(this.curr);
            localStorage.setItem("currency", this.curr);
        },
        changeCurrency(item) {
            this.$emit('changeCurrency', item);
        },
    },
    components: { RouterLink }
}
</script>
